import React from 'react'
import Profile_AV from "../../../../../assets/images/avatar.png"

const EditProfileTab = () => {
    return (

        // {/* x---------------------------------x Edit Profile / Edit Form x---------------------------------x */ }
        <div className="row" >
            {/* x---------------------------------x Edit Profile x---------------------------------x */}
            <div className="col-xl-2 col-lg-3 my-3 d-flex justify-content-lg-start justify-content-center align-items-start" >
                <div className="profile-pic position-relative">
                    <div className="position-absolute z-3 end-0 bottom-0">
                        <div className="no-thumbnail rounded-circle bg-primary p-2">
                            <svg width="20" viewBox="0 0 15 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip-two)">
                                    <path d="M14.587 4.16309L13.2364 5.51367C13.0987 5.65137 12.876 5.65137 12.7383 5.51367L9.48637 2.26172C9.34867 2.12402 9.34867 1.90137 9.48637 1.76367L10.837 0.413086C11.3848 -0.134766 12.2754 -0.134766 12.8262 0.413086L14.587 2.17383C15.1377 2.72168 15.1377 3.61231 14.587 4.16309ZM8.32621 2.92383L0.632851 10.6172L0.011757 14.1768C-0.073204 14.6572 0.345741 15.0732 0.82621 14.9912L4.38578 14.3672L12.0791 6.67383C12.2168 6.53613 12.2168 6.31348 12.0791 6.17578L8.82719 2.92383C8.68656 2.78613 8.46391 2.78613 8.32621 2.92383ZM3.63578 9.95801C3.47465 9.79688 3.47465 9.53906 3.63578 9.37793L8.1475 4.86621C8.30863 4.70508 8.56644 4.70508 8.72758 4.86621C8.88871 5.02734 8.88871 5.28516 8.72758 5.44629L4.21586 9.95801C4.05473 10.1191 3.79691 10.1191 3.63578 9.95801ZM2.57816 12.4219H3.98441V13.4854L2.09476 13.8164L1.18363 12.9053L1.51469 11.0156H2.57816V12.4219Z"
                                        fill="white"></path>
                                </g>
                                <defs>
                                    <clipPath id="clip-two">
                                        <rect width="15" height="15"
                                            fill="white"></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                        </div>
                    </div>
                    <label className="-label d-flex justify-content-center"
                        htmlFor="file">
                        <span className="glyphicon glyphicon-camera"></span>
                        <span>Change Image</span>
                    </label>
                    <input id="file" type="file" />
                    <img src={Profile_AV} id="output"
                        width="200" alt="profile-photo-two" />
                </div>
            </div>

            {/* x---------------------------------x Edit Form x---------------------------------x */}
            <div className="col-xl-10 col-lg-9 my-3" >
                <div className="row g-3">
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput1"
                            className="form-label text-dark fs-6 fw-normal ">Your
                            Name</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput1"
                            placeholder="Charlene Reed " />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput6"
                            className="form-label text-dark fs-6 fw-normal ">User
                            Name</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput6"
                            placeholder="Charlene Reed " />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput2"
                            className="form-label text-dark fs-6 fw-normal ">Email</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput2"
                            placeholder="charlenereed@gmail.com " />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput7"
                            className="form-label text-dark fs-6 fw-normal ">Password</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput7"
                            placeholder="**** ****" />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput3"
                            className="form-label text-dark fs-6 fw-normal ">Date
                            of Birth</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput3"
                            placeholder="25 January 1990" />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput8"
                            className="form-label text-dark fs-6 fw-normal ">Present
                            Address</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput8"
                            placeholder="San Jose, California, USA" />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput4"
                            className="form-label text-dark fs-6 fw-normal ">Permanent
                            Address</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput4"
                            placeholder="San Jose, California, USA" />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput9"
                            className="form-label text-dark fs-6 fw-normal ">City</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput9"
                            placeholder="San Jose" />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput5"
                            className="form-label text-dark fs-6 fw-normal ">Postal
                            Code</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput5"
                            placeholder="45962" />
                    </div>
                    <div className="col-md-6">
                        <label htmlFor="exampleFormControlInput10"
                            className="form-label text-dark fs-6 fw-normal ">Country</label>
                        <input type="email"
                            className="form-control rounded-4  form-control-lg"
                            id="exampleFormControlInput10"
                            placeholder="USA" />
                    </div>
                    <div className="col-md-12 my-3">
                        <div className="row">
                            <div className="col-md-2 ms-auto">
                                <button
                                    className="btn btn-primary w-100 rounded-3">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default EditProfileTab